import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components/App';
import * as serviceWorker from './serviceWorker';
import DesktopPage from "./components/DesktopPage";
const windowWidth =  window.innerWidth;
const isMobile = windowWidth <1024;
ReactDOM.render(
  <React.StrictMode>
    {isMobile && <style dangerouslySetInnerHTML={{
      __html: [
        `html, body,#root,#root > div{
            height: auto; 
            /*height: calc(100vh - 100px);*/ 
            position: relative;
      }`].join('\n')
    }}>
    </style>}
      { isMobile ? <App />:<DesktopPage />}
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
